import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-bottom: 24px;
  gap: 32px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media only screen and (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  @media only screen and (max-width: 1080px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
